import { render, staticRenderFns } from "./market-money.vue?vue&type=template&id=1d9319d8&"
import script from "./market-money.vue?vue&type=script&lang=js&"
export * from "./market-money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "market-money.vue"
export default component.exports